module.exports = __webpack_public_path__ + "media/images/LED-0-f296e214e7e00641780d73f7cb8ed710.png";